module.exports = __webpack_public_path__ + "static/img/6.08b40bec.png";